var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:("MainLogo " + (_vm.className || '')),style:({ width: _vm.isResponsive || false ? '100%' : ((_vm.widthImage || 200) + "px") }),attrs:{"src":_vm.image || _vm.logo}})}
var staticRenderFns = []

export { render, staticRenderFns }